module.exports = __webpack_public_path__ + "static/premier-circle-bg-7aa26d454eed4784c0ebf652ea7c7110.webp";